import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsIntegerValidator {
  constructor({ value }) {
    this.pattern = '' // TODO сделать регулярку на целое число
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_int_value" />
  }

  validate() {
    if (!Number.isInteger(this.value)) {
      return this.errorMessage
    }

    return null
  }
}
